import { Component, OnInit } from '@angular/core';

import { ModalService } from '@app/core/services/modal.service';
import { ConfigureService } from '@app/configure/services/configure.service';

import { Modal } from '@app/core/models/modal.model';

@Component({
	selector: 'cng-finance-info-modal',
	templateUrl: './finance-info.component.html',
	styleUrls: ['./finance-info.component.less'],
})
export class ConfigureFinanceInfoModalComponent implements OnInit {
	quote: any;

	/**
	 * Constructs class and injects dependencies.
	 *
	 * @param {ModalService} modal_service
	 * @param {ConfigureService} configure_service
	 */
	constructor(private modal_service: ModalService, private configure_service: ConfigureService) {
		this.constructModal();
	}

	/**
	 * Constructs modal.
	 */
	constructModal(): void {
		this.quote = this.modal_service.data.quote;

		this.modal_service.setConfig(
			new Modal({
				name: 'finance_info_modal',
				title: 'What is ' + this.quote.facility_type + ' Finance?',
				height: 'full',
			})
		);
	}

	/**
	 * Lifecycle hook: Tracks user activity.
	 */
	ngOnInit(): void {
		this.configure_service.track('modal.open', { modal: 'finance-info' }).subscribe();
	}
}
